var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookTurning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 133,
    viewBox: "0 0 180 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loading 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M172.945 89.6123L90.0223 104.128L7.09962 89.6123",
    stroke: "#A20B91",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M169.239 75.7149C124.767 84.98 90.0224 102.121 90.0224 102.121C90.0224 102.121 50.9542 82.2004 9.57019 75.7148",
    stroke: "#A20B91",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M169.239 75.7148C124.767 84.98 90.0224 102.12 90.0224 102.12",
    stroke: "#A20B91",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.738 99.0855C175.546 98.4189 179.174 100.966 179.84 104.774C180.507 108.582 177.96 112.209 174.152 112.876L104.304 125.102C103.925 129.103 97.6758 132.286 90.022 132.286C82.3683 132.286 76.1189 129.103 75.7402 125.102L5.89246 112.876C2.08437 112.209 -0.462326 108.582 0.204269 104.774C0.870865 100.966 4.49832 98.4189 8.30641 99.0855L90.0221 113.39L171.738 99.0855Z",
    fill: "#6C0360"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookTurning);
export default __webpack_public_path__ + "static/media/book-turning.3783d60d8edd95e497ccd5e5ce5d27f3.svg";
export { ForwardRef as ReactComponent };